import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';

import { changeSubSwitchValueByNotifIdAndTaskTypeId } from 'features/views/settings/actions';
import { getSubSwitchByNotifIdAndTaskType } from 'features/views/settings/selectors';

export const SettingsSubSwitch = ({ filter }) => {
	const dispatch = useDispatch();

	const { notificationSetId, taskTypeId, description } = filter;

	const chosenSubSwitch = useSelector((state) =>
		getSubSwitchByNotifIdAndTaskType(state, notificationSetId, taskTypeId),
	);

	const handleToggleSubSwitch = useCallback(() => {
		dispatch(changeSubSwitchValueByNotifIdAndTaskTypeId(notificationSetId, taskTypeId));
	}, [dispatch, notificationSetId, taskTypeId]);

	return (
		<Stack
			direction="row"
			spacing={1}
			sx={{
				alignItems: 'center',
			}}
		>
			<Switch
				checked={chosenSubSwitch.enabled}
				onChange={handleToggleSubSwitch}
				disabled={!chosenSubSwitch.allowedChanges}
			/>
			<Typography variant="subtitle">{description}</Typography>
		</Stack>
	);
};

SettingsSubSwitch.propTypes = {
	filter: PropTypes.object,
};

export default SettingsSubSwitch;
